import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const Cursor = () => {
  const [label, setLabel] = useState("");
  const [hovering, setHovering] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const dotX = useSpring(x, { stiffness: 900, damping: 50, mass: 0.2 });
  const dotY = useSpring(y, { stiffness: 900, damping: 50, mass: 0.2 });
  const ringX = useSpring(x, { stiffness: 180, damping: 22, mass: 0.5 });
  const ringY = useSpring(y, { stiffness: 180, damping: 22, mass: 0.5 });

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    setEnabled(true);
    document.body.classList.add("custom-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const labelled = e.target.closest("[data-cursor]");
      setLabel(labelled ? labelled.dataset.cursor : "");
      setHovering(!!e.target.closest("a, button, [role='button'], input, select, textarea, label"));
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      document.body.classList.remove("custom-cursor");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      {/* trailing ring */}
      <motion.div className="pointer-events-none fixed left-0 top-0 z-[99]" style={{ x: ringX, y: ringY }}>
        <motion.div
          animate={{
            width: label ? 0 : hovering ? 44 : 32,
            height: label ? 0 : hovering ? 44 : 32,
            opacity: label ? 0 : 0.7,
          }}
          transition={{ duration: 0.3 }}
          style={{ transform: "translate(-50%, -50%)" }}
          className="rounded-full border border-[#C5A059]/70"
        />
      </motion.div>
      {/* dot / label badge */}
      <motion.div
        data-testid="custom-cursor"
        className="pointer-events-none fixed left-0 top-0 z-[100]"
        style={{ x: dotX, y: dotY }}
      >
        <motion.div
          animate={{
            width: label ? 76 : 10,
            height: label ? 76 : 10,
            backgroundColor: label ? "#C5A059" : "rgba(197,160,89,0.9)",
          }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          style={{ transform: "translate(-50%, -50%)" }}
          className="flex items-center justify-center rounded-full"
        >
          {label && (
            <span className="font-mono text-[9px] tracking-[0.22em] text-[#0B0B0C]">{label}</span>
          )}
        </motion.div>
      </motion.div>
    </>
  );
};
